// extracted by mini-css-extract-plugin
module.exports = {"c-container":"_1Vvhzr-n0MNN5zElJ5T02O"};